export default "/images/vendor/flag-icon-css/flags/1x1/fo.svg?a004f63d8cf851543b799fc2b6404b62";